import React from 'react';
import { completePayment } from 'Services/Api/_HumanWritten/PaymentService';
import { stringIsEmpty } from 'Util/TypeGuards';
import { PostPaymentRender } from './PostPaymentRender';

export interface PostPaymentProps {
	onSuccess: (transactionId: string) => void;
	onPaymentFailed: (errorCode: string) => void;
	className?: string;
	paymentIntentId?: string;
}

export function PostPayment({ onSuccess, onPaymentFailed, className, paymentIntentId }: PostPaymentProps) {
	const hasCalledPaymentRef = React.useRef<string | null>(null);

	React.useEffect(() => {
		if (stringIsEmpty(paymentIntentId)) {
			return;
		}

		// Prevent duplicate calls for the same payment intent
		if (hasCalledPaymentRef.current === paymentIntentId) {
			return;
		}

		hasCalledPaymentRef.current = paymentIntentId;

		completePayment(paymentIntentId, false)
			.then(result => {
				onSuccess(result.data);
			})
			.catch(e => {
				onPaymentFailed(e.response?.data ?? 'Error');
			});
	}, [paymentIntentId, onSuccess, onPaymentFailed]);

	return <PostPaymentRender className={className} />;
}
